// ----------------------------------------------------------------------
// <copyright file="Izenda.PrintConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

const PAGE_SIZES = {
  A0: {
    widthInInches: 33.1,
    heightInInches: 46.8
  },
  A1: {
    widthInInches: 23.4,
    heightInInches: 33.1
  },
  A2: {
    widthInInches: 16.5,
    heightInInches: 23.4
  },
  A3: {
    widthInInches: 11.7,
    heightInInches: 16.5
  },
  A4: {
    widthInInches: 8.25,
    heightInInches: 11.69
  },
  A5: {
    widthInInches: 5.8,
    heightInInches: 8.3
  }
};

const ORIENTATION = {
  PORTRAIT: 0,
  LANDSCAPE: 1
};

const DEFAULT_PAGE_SIZE_KEY = 'A4';
const HEADER_HEIGHT = 3.12; // 300px
const MIN_SIZE_UI_SETTING = 0.02; // in inches

export default {
  PAGE_SIZES,
  DEFAULT_PAGE_SIZE_KEY,
  MIN_SIZE_UI_SETTING,

  /**
   * Calculate size of content (in inches)
   * @param  {String} pageSizeKey
   * @param  {Object} pageMargins
   * @param  {Number} headerMargin
   * @param  {Number} footerMargin
   * @param  {String} orientation
   */
  getContentSizeInInches(pageSizeKey, pageMargins, headerHeightInInches, footerHeightInInches, orientation) {
    const pageSize = PAGE_SIZES[pageSizeKey];
    if (!pageSize) return null;

    let widthOfPrintPageInInches;
    let heightOfPrintPageInInches;
    if (!orientation || orientation === ORIENTATION.PORTRAIT) {
      widthOfPrintPageInInches = pageSize.widthInInches;
      heightOfPrintPageInInches = pageSize.heightInInches;
    } else {
      widthOfPrintPageInInches = pageSize.heightInInches;
      heightOfPrintPageInInches = pageSize.widthInInches;
    }

    const widthOfContentInInches = widthOfPrintPageInInches;
    const heightOfContentInInches = heightOfPrintPageInInches;

    return {
      widthOfContentInInches,
      heightOfContentInInches
    };
  },

  /**
   * Calculate size of content (in inches)
   * @param  {String} pageSizeKey
   * @param  {Object} pageMargins
   * @param  {Number} headerMargin
   * @param  {Number} footerMargin
   * @param  {String} orientation
   */
  getBodyContentSizeInInches(pageSizeKey, pageMargins, headerHeightInInches, footerHeightInInches, orientation) {
    const pageSize = PAGE_SIZES[pageSizeKey];
    if (!pageSize) return null;

    let widthOfPrintPageInInches;
    let heightOfPrintPageInInches;
    if (!orientation || orientation === ORIENTATION.PORTRAIT) {
      widthOfPrintPageInInches = pageSize.widthInInches;
      heightOfPrintPageInInches = pageSize.heightInInches;
    } else {
      widthOfPrintPageInInches = pageSize.heightInInches;
      heightOfPrintPageInInches = pageSize.widthInInches;
    }

    const widthOfContentInInches = widthOfPrintPageInInches - (pageMargins.left + pageMargins.right);
    const heightOfContentInInches =
      heightOfPrintPageInInches - (pageMargins.top + pageMargins.bottom + headerHeightInInches + footerHeightInInches);

    return {
      widthOfContentInInches,
      heightOfContentInInches
    };
  },

  /**
   * Format CSS value in inches string.
   * @param  {Number} value
   */
  formatCSSValueInInches(value, isFirstReportPart) {
    return `${value}in`;
  },

  /**
   * get container height in inches string.
   * @param  {Number} value
   */
  getContainerHeight(height, isFirstReportPart) {
    const value = isFirstReportPart ? height - HEADER_HEIGHT : height;
    return `${value}in`;
  },

  /**
   * Format CSS value in percent string.
   * @param  {Number} value
   */
  formatCSSValueInPercent(value) {
    return `${value}%`;
  },

  getPageSize(pageSizeKey, orientation) {
    let widthOfPrintPageInInches;
    let heightOfPrintPageInInches;

    pageSizeKey = pageSizeKey || DEFAULT_PAGE_SIZE_KEY;
    const pageSize = PAGE_SIZES[pageSizeKey];

    if (!orientation || orientation === ORIENTATION.PORTRAIT) {
      widthOfPrintPageInInches = pageSize.widthInInches;
      heightOfPrintPageInInches = pageSize.heightInInches;
    } else {
      widthOfPrintPageInInches = pageSize.heightInInches;
      heightOfPrintPageInInches = pageSize.widthInInches;
    }

    return {
      widthInInches: widthOfPrintPageInInches,
      heightInInches: heightOfPrintPageInInches
    };
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.PrintConstants.js